<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
    :form-class-name="formClassName"
  >
    <template #label>
      <slot name="label" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #body>
      <fieldset>
        <template v-for="(option, i) in options">
          <label
            :key="`${optionKeyLabel}-${i}`"
            class="pega-badge-radio pega-mr-5"
            :class="labelClassName"
          >
            <input
              :data-test="`${optionKeyLabel}-option-${i}`"
              :type="type"
              :value="option.id"
              :class="className"
              :checked="value === option.id"
              :disabled="disabled"
              @click="changeValue($event.target._value)"
            ><span
              :class="valueClassName"
              :data-test="`${optionKeyLabel}-option-label-${i}`"
            >
              {{ option.name }}
            </span>
          </label>
        </template>
        <slot name="suffix" />
        <validation-label
          v-if="validation.isShow"
          :label="validation.message"
        />
        <div class="pega-mt-05">
          <span>備考<small
            class="pega-ml-1"
            data-test="count"
          >{{ remarks ? remarks.length : 0 }}文字/ {{ maxCharacter }}文字</small></span>
        </div>
        <textarea
          :value="remarks"
          :class="className"
          :placeholder="placeholder"
          class="pega-form-item pega-textarea-low pega-textarea-vertical"
          data-test="item"
          @input="$emit('update:remarks', $event.target.value)"
        />
      </fieldset>
    </template>
    <template #error>
      <slot name="error" />
    </template>
  </form-label>
</template>

<script>
import FormLabel from '@/components/atoms/FormLabel'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    FormLabel,
    ValidationLabel
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'radio'
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    labelClassName: {
      type: String,
      default: ''
    },
    valueClassName: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxCharacter: {
      default: 0,
      type: Number
    },
    value: {
      type: Number,
      default: 0
    },
    remarks: {
      type: String,
      default: ''
    },
    optionKeyLabel: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isOptional: {
      type: Boolean,
      default: false
    },
    formClassName: {
      type: String,
      default: ''
    }
  },
  computed: {
    validation () {
      return {
        isShow: !this.isOptional && this.value === 0,
        message: '選択してください'
      }
    }
  },
  methods: {
    changeValue (val) {
      if (this.isOptional && this.value === val) {
        // 任意項目かつ、同じ選択肢を2回押下した場合、未選択状態へ
        this.$emit('input', 0)
      } else {
        this.$emit('input', val)
      }
    }
  }
}
</script>
